import React, { useEffect, useState } from 'react';

interface SmallHeroProps {
  title: string;
  subtitle?: string;
}

interface AnimationStyle {
  opacity: number;
  transform: string;
  transition: string;
}

const SmallHero: React.FC<SmallHeroProps> = ({ title, subtitle }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const baseStyle: AnimationStyle = {
    opacity: 0,
    transform: 'translateY(20px)',
    transition: 'opacity 800ms ease-out, transform 800ms ease-out'
  };

  const visibleStyle = {
    opacity: 1,
    transform: 'translateY(0)'
  };

  return (
    <header className="py-32 relative overflow-hidden bg-gradient-to-br from-[#00529B] to-[#003D74]">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto text-center">
          <h1 
            className="text-5xl md:text-6xl font-bold text-white mb-6"
            style={{
              ...baseStyle,
              ...(isVisible ? visibleStyle : {}),
              transitionDelay: '0ms'
            }}
          >
            {title}
          </h1>
          {subtitle && (
            <p 
              className="text-2xl text-gray-200 max-w-3xl mx-auto leading-relaxed"
              style={{
                ...baseStyle,
                ...(isVisible ? visibleStyle : {}),
                transitionDelay: '100ms'
              }}
            >
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </header>
  );
};

export default SmallHero;
